import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class ProductSaleUrgencyNotice extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateNotice);
  }

  /**
   * Updates the sale urgency notice when the selected variant changes.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateNotice = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newNotice = event.detail.data.html.querySelector(
      `product-sale-urgency-notice[data-block-id="${this.dataset.blockId}"]`
    );
    if (!newNotice) return;

    morph(this, newNotice, { childrenOnly: true });
  };
}

if (!customElements.get('product-sale-urgency-notice')) {
  customElements.define('product-sale-urgency-notice', ProductSaleUrgencyNotice);
}
